export default __webpack_public_path__ + "static/adelie-logo-99647d42e047092e7d0f47d61576ffda.png";